// extracted by mini-css-extract-plugin
module.exports = {"explanations":"bf_gc","explanations__item":"bf_gd","explanations__title":"bf_gf","explanations__text":"bf_gg"};